export interface ManualChapter {
  id: string;
  number: number;
  title: string;
  content: string;
}

export interface ManualSection {
  id: string;
  title: string;
  chapters: ManualChapter[];
}

export interface FaqItem {
  id: string;
  question: string;
  answer: string;
  category: FaqCategory;
}

export type FaqCategory =
  | 'general'
  | 'pricing'
  | 'cotizaciones'
  | 'aprobaciones'
  | 'datos-maestros'
  | 'ia'
  | 'cuenta'
  | 'tecnico'
  | 'pricing-dinamico'
  | 'smart-pricing'
  | 'descuentos'
  | 'reglas-pricing'
  | 'clientes'
  | 'importaciones'
  | 'integraciones';

export const FAQ_CATEGORIES: { value: FaqCategory; label: string }[] = [
  { value: 'general', label: 'General' },
  { value: 'pricing', label: 'Modelos de precio' },
  { value: 'cotizaciones', label: 'Cotizaciones' },
  { value: 'aprobaciones', label: 'Aprobaciones' },
  { value: 'datos-maestros', label: 'Datos Maestros' },
  { value: 'clientes', label: 'Clientes' },
  { value: 'importaciones', label: 'Comercia' },
  { value: 'ia', label: 'Inteligencia artificial' },
  { value: 'cuenta', label: 'Cuenta' },
  { value: 'tecnico', label: 'Técnico' },
  { value: 'pricing-dinamico', label: 'Compite' },
  { value: 'smart-pricing', label: 'Estrategias y decisiones' },
  // «Descuentos» ya no es una pantalla: su única pregunta («¿Dónde quedaron?») va en Estrategias y decisiones.
  { value: 'reglas-pricing', label: 'Reglas' },
  { value: 'integraciones', label: 'Integraciones' },
];

export interface QuickStartStep {
  number: number;
  title: string;
  description: string;
  details: string[];
  link?: string;
}

export interface SlaPlan {
  name: string;
  price: string;
  highlighted?: boolean;
  metrics: Record<string, string>;
}
